<template>
  <v-container fluid class="pa-0 align-start d-flex flex-column sign-in-container">
    <v-row no-gutters class="flex-grow-1 w-100 sign-in-main-row">
      <v-col align="center" class="pa-6 sign-in-left-col">
        <div class="sign-in-content-wrapper">
          <div class="sign-in-up ma-auto text-left sign-in-up-inner">
            <h1 class="welcome-message pb-1 font-weight-regular" v-html="this.$t('message.SSOConfirmAccountTitle' )"
                v-if="$route.name === 'confirm'"></h1>
            <h1 class="welcome-message pb-1 font-weight-regular" v-html="welcomeMessage"
                v-if="$route.name === 'signin'"></h1>
            <v-row class="mt-4 mt-sm-6" dense v-if="$route.name === 'signin' || $route.name === 'confirm' ">
              <v-col
                  v-for="( provider, index ) in ssoProviders"
                  :key="provider.name"
              >
                <sso-button
                    :provider="provider"
                    :disabled="ssoLoading"
                    @click="initiateSso( provider.name )"
                />
              </v-col>
            </v-row>
            <v-row align="center" class="mb-2 mb-sm-4" v-if="$route.name === 'signin' || $route.name === 'confirm' ">
              <v-col>
                <v-divider></v-divider>
              </v-col>
              <v-col cols="auto" class="px-4">
                <span class="text--secondary">{{ $t( 'message.Or' ) }}</span>
              </v-col>
              <v-col>
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <h1 class="welcome-message pb-1 font-weight-regular" v-html="welcomeMessage"
                v-if="$route.name === 'confirm' || $route.name === 'resetpw'"></h1>
            <signhero-login-control scope="shio.*" :messages="messages"/>
          </div>
          <div class="hidden-md-and-up no-account-small-screen pt-6">
            <v-divider class="pb-6"></v-divider>
            <h1 class="welcome-message font-weight-regular text-center pb-3"
                v-html="$t( 'message.DontHaveSignHeroAccount' )"></h1>
            <p>
              <v-btn class="primary-btn" to="/signup">{{ $t( "message.GetStarted" ) }}</v-btn>
            </p>
          </div>
        </div>
      </v-col>
      <v-col class="dark-image-bg pa-6 hidden-sm-and-down">
        <v-row align="center" class="fill-height">
          <v-flex>
            <h1 class="welcome-message font-weight-regular text-center my-3"
                v-html="$t( 'message.DontHaveSignHeroAccount' )"></h1>
            <p class="pt-3">
              <v-btn class="primary-btn" to="/signup">{{ $t( "message.GetStarted" ) }}</v-btn>
            </p>
          </v-flex>
        </v-row>
      </v-col>
    </v-row>
    <sh-app-footer :isApp="false" class="w-100 mt-auto pb-0 ma-0"></sh-app-footer>
  </v-container>
</template>

<script>
    import AppFooter from "../../components/common/AppFooter";
    import SignHeroLoginControl from "../../components/signedout/SignHeroLoginControl";
    import { JSONPureClient } from "@cloudlace/client";
    import SsoButton from "../common/SsoButton";
    import ssoSignupServiceMap from "@/api/sso-signup-service-map";
    import axios from 'axios';

    const signedOutProvider = new JSONPureClient( {
        service_url : process.env.VUE_APP_SERVICE_SIGNEDOUT_URL,
        service_map : ssoSignupServiceMap
    } );

    export default {
        name : "SignInPane.vue",
        data()
        {
            return {
                ssoLoading : false,
                messages : {
                    "ForgotYourPassword" : this.$t( 'message.IForgotMyPassword' ),
                    "Action!SignIn" : this.$t( 'message.SignIn' ),
                    "Error!TokenCheckFailed" : this.$t( 'message.ResetPWError' ),
                },
                welcomeMessage : this.$router.currentRoute.name
                                 === 'resetpw' ? this.$t( 'message.ResetPasswordTitle' ) :
                this.$router.currentRoute.name
                === 'confirm' ? this.$t( 'message.ConfirmAccountTitle' ) : this.$t(
                'message.WelcomeMessage' ),
                ssoProviders : [
                    { name : 'google', label : 'Google' },
                    { name : 'microsoft', label : 'Microsoft' },
                    // { name : 'apple', label : 'Apple' },
                    // { name : 'linkedin', label : 'LinkedIn' }
                ]
            }
        },
        components : {
            "sh-app-footer" : AppFooter,
            "signhero-login-control" : SignHeroLoginControl,
            "sso-button" : SsoButton
        },
        methods : {
            /**
             * Initiating the SSO login process.
             */
            initiateSso( provider )
            {
                if( this.ssoLoading )
                {
                    return;
                }
                new Promise( ( resolve, reject ) =>
                {
                    this.ssoLoading = true;
                    let redirectUrl = null;
                    if( this.$route.name === 'confirm' && this.$route.query.token )
                    {
                        redirectUrl = `/#/confirm?token=${this.$route.query.token}&sso_action=confirm`;
                    }
                    else if( this.$route.query.client_id )
                    {
                        const searchParams = new URLSearchParams( this.$route.query );
                        redirectUrl = `/oauth2/authorize?${searchParams.toString()}`;
                    }
                    const currentLocale = this.$i18n.locale || 'en';
                    axios.post( process.env.VUE_APP_SSO_GATEWAY_URL,
                    {
                        provider : provider,
                        return_url : redirectUrl,
                        locale : currentLocale
                    },
                    {
                        withCredentials : true
                    } ).then( response =>
                    {
                        const targetUrl = response.data?.authorization_url;
                        targetUrl
                        ? resolve( targetUrl )
                        : reject();
                    } ).catch( err =>
                    {
                        reject( err );
                    } );
                } ).then( url =>
                {
                    window.location.href = url;
                } ).catch( err =>
                {
                    this.$error( this.$t( "message.Error!InvalidSSO" ) );
                    this.ssoLoading = false;
                } );
            }
        }
    }
</script>

<style lang="sass">
  @import "../../styles/style"
  .sign-in-container
    min-height: 100% !important
    height: 100% !important
    flex-grow: 1

  .sign-in-main-row
    width: 100%

  .sign-in-left-col
    display: flex !important
    flex-direction: column
    justify-content: flex-start
    padding-top: 0 !important
    padding-bottom: 0 !important

  .sign-in-content-wrapper
    width: 100%
    max-width: 600px
    margin: auto
    padding: 24px 0

  .sign-in-up-inner
    width: 100%

  .cvw-change-password a
    color: $text-black !important
    font-size: 14px
    text-decoration: underline

  .cvw-change-password a:hover
    color: $vivid-pink !important
    font-size: 14px
    text-decoration: underline

  .cvw-change-password
    text-align: right

  .control-node
    text-align: center !important

  .no-account-small-screen
    max-width: 450px

  .cvw-status-message
    font-size: 14px !important
    padding: 10px
    box-sizing: border-box
    background-color: $light-grey
    cursor: pointer
    color: $text-black
    margin-top: 15px

  .cvw-sign-in-btn.v-btn.theme--light.v-size--default,
  .cvw-confirm-account-btn.v-btn.theme--light.v-size--default,
  .cvw-set-password-btn
    background-color: $vivid-pink !important
    border-color: $vivid-pink !important
    min-width: 200px !important
    width: auto !important
    height: 40px !important
    font-size: 16px !important
    box-shadow: none

  .cvw-sign-in-btn.v-btn--disabled.theme--light,
  .cvw-confirm-account-btn.v-btn--disabled.theme--light,
  .cvw-set-password-btn.v-btn.v-btn--disabled.v-btn--has-bg
    background-color: $vivid-pink !important
    opacity: 0.5
    color: white !important
    height: 40px
    font-size: 16px
    text-transform: none

  .cvw-sign-in-btn.v-btn.theme--light:hover
    background-color: $dark-pink !important
</style>